export const sortPlaylistBites = (bites) => bites.sort((prev, next) => (prev.order > next.order ? 1 : -1));
